import { Component, OnInit } from '@angular/core';

import { faQuestion, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'dx-page-navbar',
  templateUrl: './page-navbar.component.html',
  styleUrls: ['./page-navbar.component.scss']
})
export class PageNavbarComponent implements OnInit {

  iconQuestion = faQuestion;
  iconArrow = faArrowLeft;

  constructor() { }

  ngOnInit() {
  }

}
